<template>
	<div class="blankslate" :class="styles">
		<div class="blankslate-icon">
			<slot name="icon">
				<v-icon :x-small="xSmall" :small="small" :large="large" :x-large="xLarge" :class="color">{{icon}}</v-icon>
			</slot>
		</div>
		<div class="blankslate-label" :class="labelstyle">
			<slot>{{label}}</slot>
		</div>
		<div class="blankslate-sublabel" :class="sublabelStyle">
			<slot name="sublabel">{{sublabel}}</slot>
		</div>
	</div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class Blankslate extends Vue {
	@Prop() icon: string;
	@Prop() label: string;
	@Prop() sublabel: string;
	@Prop() color: string;
	@Prop({ type: Boolean, default: false }) xSmall: boolean;
	@Prop({ type: Boolean, default: false }) small: boolean;
	@Prop({ type: Boolean, default: false }) large: boolean;
	@Prop({ type: Boolean, default: false }) xLarge: boolean;
	@Prop({ type: Boolean, default: false }) column: boolean;

	get size() {
		if (this.xSmall)
			return "blankslate--x-small";
		if (this.small)
			return "blankslate--small";
		if (this.large)
			return "blankslate--large";
		if (this.xLarge)
			return "blankslate--x-large";
		return "";
	}

	get layout() {
		if (this.column)
			return "blankslate--column";
		return "";
	}

	get styles() {
		return [this.color, this.size, this.layout];
	}

	get labelstyle() {
		if (this.xSmall)
			return "text-subtitle-1"; // 16
		if (this.small)
			return "text-h6"; // 20
		if (this.large)
			return "text-h4"; // 34
		if (this.xLarge)
			return "text-h3"; // 45
		return "text-h5"; // 24
	}

	get sublabelStyle() {
		if (this.xSmall)
			return "text-body-2"; // 14
		if (this.small)
			return "text-subtitle-1"; // 16
		if (this.large)
			return "text-h5"; // 24
		if (this.xLarge)
			return "text-h4"; // 34
		return "text-h6"; // 20
	}
}
</script>

<style lang="scss">
	.blankslate {
		display: grid;
		padding: 0.5em;
		grid-template-areas:
			"icon label"
			"icon sublabel";
		grid-template-columns: min-content auto;
		grid-template-rows: auto;
		align-items: center;
		grid-gap: 0 0.5em;
		font-size: 16px;

		&--column {
			grid-template-areas:
				"icon"
				"label"
				"sublabel";
			grid-template-columns: auto;
			grid-template-rows: auto;
			justify-items: center;
		}
	}

	.blankslate-icon {
		grid-area: icon;
	}

	.blankslate-label {
		grid-area: label;
	}

	.blankslate-sublabel {
		grid-area: sublabel;
	}
</style>